import { Inline } from "PFComponents/containers/flex/inline";
import { Icon } from "PFComponents/icon";
import { IconProps } from "PFComponents/icon";
import { ReadOnlyField } from "PFComponents/read_only_field";
import { ProfileCustomValue } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "../custom_value_preview.module.scss";

type VerifiedIconsProps = {
  profileConnection?: ProfileCustomValue;
};

type IconWithTitleProps = {
  title: string;
} & IconProps;

const IconWithTitle = ({ title, ...props }: IconWithTitleProps) => (
  <div title={title}>
    <Icon {...props} />
  </div>
);

export const VerifiedIcons = ({ profileConnection }: VerifiedIconsProps) => {
  const { t } = useTranslation();
  const { t: tCore } = useTranslation("core");

  const isVerified = profileConnection?.assessed;
  const isCredlySource = profileConnection?.assessmentSource === "credly";
  const isVerifiedOthers = !!profileConnection?.emVerified;

  if (!isVerified && !isVerifiedOthers) {
    return null;
  }

  return (
    <ReadOnlyField
      classes={{ root: css.halfWidth }}
      label={t("customValueSidepanel.verified")}
      value={
        <Inline gap="spacingMd">
          {isVerified &&
            (isCredlySource ? (
              <IconWithTitle name="verified-credly" title={tCore("skillBadge.assessment.credly")} />
            ) : (
              <IconWithTitle name="verified" title={tCore("skillBadge.assessment.assessed")} />
            ))}
          {isVerifiedOthers && (
            <IconWithTitle name="verified-others" title={tCore("skillBadge.assessment.feedback")} />
          )}
        </Inline>
      }
    />
  );
};
